/** 8 bit mono PCM の無音 WAV を data URL で返す。 */
export function silentWavDataUrl(seconds = 0.05, sampleRate = 8000): string {
  const n = Math.round(seconds * sampleRate);
  const buf = new ArrayBuffer(44 + n);
  const v = new DataView(buf);
  const w = (o: number, s: string) => [...s].forEach((ch, i) => v.setUint8(o + i, ch.charCodeAt(0)));
  w(0, 'RIFF'); v.setUint32(4, 36 + n, true); w(8, 'WAVE');
  w(12, 'fmt '); v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, 1, true);
  v.setUint32(24, sampleRate, true); v.setUint32(28, sampleRate, true); v.setUint16(32, 1, true); v.setUint16(34, 8, true);
  w(36, 'data'); v.setUint32(40, n, true);
  new Uint8Array(buf, 44).fill(128); // 8 bit PCM の無音は 128
  let s = '';
  for (const b of new Uint8Array(buf)) s += String.fromCharCode(b);
  return `data:audio/wav;base64,${btoa(s)}`;
}

/** iPadOS はデスクトップ UA を名乗るので maxTouchPoints も見る。 */
export function isIOS(ua: string, maxTouchPoints = 0): boolean {
  return /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && maxTouchPoints > 1);
}

/**
 * iOS では Web Audio の出力が消音スイッチに従う。無音の <audio> をループ再生しておくと
 * 音声セッションが「再生」カテゴリに切り替わり、Web Audio も鳴るようになる(swevans/unmute と同じ手法)。
 * kick() はユーザー操作のハンドラ内で呼ぶ。前面復帰時にも呼び直す。
 */
export class IosUnmute {
  private readonly el: HTMLAudioElement;
  private readonly onVisible = () => { if (document.visibilityState === 'visible') void this.el.play().catch(() => {}); };

  constructor() {
    this.el = document.createElement('audio');
    this.el.src = silentWavDataUrl();
    this.el.loop = true;
    this.el.setAttribute('playsinline', '');
    this.el.preload = 'auto';
    document.addEventListener('visibilitychange', this.onVisible);
  }

  kick(): void {
    void this.el.play().catch(() => {});
  }

  dispose(): void {
    document.removeEventListener('visibilitychange', this.onVisible);
    this.el.pause();
    this.el.src = '';
  }
}
